import "./App.css";
import ProductAndServices from "./Pages";
import RouteComponent from "./routes";

function App() {
  return (
    <div>
      {/* <ProductAndServices /> */}
      <RouteComponent/>
    </div>
  );
}
export default App;
